import "./PromoTextBlock.scss";
import { GridPresetOneHalf, GridRow, OptimizelyEditProperty, LinkHeroFrontpage } from "/App.Components";
import { PromoTextBlockProps } from "/Models/Generated/PromoTextBlockProps";

const PromoTextBlock = ({
  title,
  titlePropertyName,
  description,
  descriptionPropertyName,
  readMoreLink,
  readMoreLinkPropertyName,
}: PromoTextBlockProps) => (
  (title ?? "").trim() === "" && (description ?? "").trim() === "" ? null : (
  <section className="promo-text-block-norad promo-text-block-norad--insight">
    <div className="promo-text-block-norad__inner">
      <GridRow>
        <GridPresetOneHalf>
          <OptimizelyEditProperty propertyName={titlePropertyName}>
            {title && <h2 className="promo-text-block-norad__title">{title}</h2>}
          </OptimizelyEditProperty>
        </GridPresetOneHalf>

        <GridPresetOneHalf>
          <div className="promo-text-block-norad__content">
            <OptimizelyEditProperty propertyName={descriptionPropertyName}>
              {description && (
                <p className="promo-text-block-norad__description">{description}</p>
              )}
            </OptimizelyEditProperty>
          </div>
          <OptimizelyEditProperty propertyName={readMoreLinkPropertyName}>
            <div className="promo-text-block-norad__link-container">
              {readMoreLink && <LinkHeroFrontpage {...readMoreLink} />}
            </div>
          </OptimizelyEditProperty>
        </GridPresetOneHalf>
      </GridRow>
    </div>
  </section>
  )
);

export default PromoTextBlock;